import { Dialog } from "@fronterahealth/frontera-ui-components";

interface DeleteFolderDialogProps {
  onDeleteClick: () => void;
  onCancelClick: () => void;
  open: boolean;
  /** Name of the folder being deleted, so the confirmation names what it is about to remove. */
  folderName?: string;
  /**
   * What the folder holds. The recommendations banks reuse this dialog, so the default
   * ("goals and targets") would be wrong there.
   */
  contentsLabel?: string;
}

export const DeleteFolderDialog: React.FC<DeleteFolderDialogProps> = ({
  onDeleteClick,
  onCancelClick,
  open,
  folderName,
  contentsLabel = "goals and targets",
}) => {
  return (
    <Dialog
      size="xl"
      showCloseButton={false}
      title="Delete Folder"
      open={open}
      setOpen={() => {}}
      primaryButton={{
        text: "Yes, Delete",
        onClick: onDeleteClick,
        type: "submit",
        buttonAction: "destructive",
      }}
      secondaryButton={{
        text: "No, Cancel",
        onClick: onCancelClick,
      }}
    >
      <div className="py-2 text-text-primary text-base">
        Are you sure you want to delete{" "}
        {folderName ? <span className="font-semibold">{folderName}</span> : "this folder"}? You will lose all{" "}
        {contentsLabel} within the folder. This action cannot be undone.
      </div>
    </Dialog>
  );
};
